import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var CreateSecretCommandClass;
function CreateSecretCommand() {
  if (CreateSecretCommandClass === VOID) {
    class $ {
      constructor(partyId, description) {
        this.g2m_1 = partyId;
        this.h2m_1 = description;
      }
      toString() {
        return 'CreateSecretCommand(partyId=' + this.g2m_1.toString() + ', description=' + this.h2m_1 + ')';
      }
      hashCode() {
        var result = this.g2m_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.h2m_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretCommand()))
          return false;
        if (!this.g2m_1.equals(other.g2m_1))
          return false;
        if (!(this.h2m_1 === other.h2m_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretCommand');
    CreateSecretCommandClass = $;
  }
  return CreateSecretCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher3f3rv68jjbf7x,
  CreateSecretCommand as CreateSecretCommand3rplw01dtlqbx,
};
//endregion

//# sourceMappingURL=CreateSecretCommand.mjs.map
